import Api from './ApiService'

export default {
    get({ keyword = '', pageNumber = 1, pageSize = 20, AdmId = '', action = '', dateFrom = '', dateTo = '' } = {}) {
        let url = `audit?keyword=${encodeURIComponent(keyword)}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
        if (AdmId) url += `&AdmId=${AdmId}`;
        if (action) url += `&action=${encodeURIComponent(action)}`;
        if (dateFrom) url += `&dateFrom=${dateFrom}`;
        if (dateTo) url += `&dateTo=${dateTo}`;
        return Api().get(url);
    },
    getActions() {
        return Api().get('audit/actions');
    }
}
